import { render } from "./DetalhesPedidoEmAndamento.vue?vue&type=template&id=e41b61b6&scoped=true"
import script from "./DetalhesPedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./DetalhesPedidoEmAndamento.vue?vue&type=script&lang=js"

import "./DetalhesPedidoEmAndamento.vue?vue&type=style&index=0&id=e41b61b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41b61b6"]])

export default __exports__